import { Who } from '../components';

const WhosFor = () => {
   return <Who showDetails />;
};
export default WhosFor;
